import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "24",
  fill: "none",
  viewBox: "0 0 26 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M22.474 19.703c-.832.122-1.76-.95-2.948-1.004-1.187-.053-2.361 1.041-3.548.988-1.188-.053-2.001-1.429-3.188-1.482s-1.7.988-3.068.988-2.41-.99-3.368-.988c-.959.002-2.406.494-2.406.494m0-4.329C2.72 12.568 1.42 10.703 1.842 9.703s2.527-1 5.895 0 6.384 1.542 8.842 2 6.316 1 6.316 1 0 1.992-.456 3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M1 15.204s2.535-.945 4.21-1c1.677-.056 3.702 1.626 5.053 1.499 1.352-.128 2.122-.638 3.369-.499s2.328.991 3.368 1c1.04.007 1.95-.913 2.948-1 .997-.087 1.528.587 2.526.5.997-.088 2.526-1 2.526-1M14.5 5.5S12 8.5 12 10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M22.895 12.703s-8.421-4-5.895-4.5c2.526-.499 2.526-1 2.105-1.5s-7.146-2.859-9.263-1c-2.116 1.86-2.105 4-2.105 4"
    }, null, -1)
  ]))]))
}
export default { render: render }